<template>
  <div>
    <loader :loader="sending" />
    <v-text-field
      v-model="searchPsychoConsultations"
      append-icon="mdi-magnify"
      label="Buscar"
      single-line
      hide-details
      class="mx-5 mb-3"
    ></v-text-field>
    <v-data-table
      :headers="headersPsychoConsulting"
      :items="listPsychoConsultations"
      :search="searchPsychoConsultations"
      :items-per-page="10"
      :footer-props="{
        'items-per-page-text': 'Elementos por página',
        'items-per-page-all-text': 'Todo',
      }"
      no-results-text="Sin resultados coincidentes con la búsqueda"
      loading-text="Cargando..."
      no-data-text="Sin resultados disponibles"
      class="mx-5"
      dense
      fixed-header
      height="auto"
    >
      <template v-slot:[`item.diagnostic`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span color="red" dark v-bind="attrs" v-on="on">
              {{ item.diagnostic }}
            </span>
          </template>
          <span>{{ item.diagnostic1 }}</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.count`]="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="
                generatePDF(
                  item.idMedicalPractice,
                  item.registrationDate,
                  item.idPatient
                )
              "
              :disabled="item.idDiagnostic == null"
            >
              <v-icon color="red" dark v-bind="attrs" v-on="on">
                mdi-file-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span>Descargar consulta PDF</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { PsychologyHistorialService } from "@/app/services";
import moment from "moment";
import Loader from "@/app/components/base/loader/Loader.vue";
export default {
  props: {
    listPsychoConsultations: Array,
  },
  components:{
    Loader,
  },
  data() {
    return {
      searchPsychoConsultations: "",
      headersPsychoConsulting: [
        { text: "#", value: "count" },
        { text: "Id Consulta", value: "idMedicalPractice" },
        { text: "Fecha de solicitud", value: "registrationDate" },
        { text: "Fecha de consulta", value: "consultationDate" },
        { text: "Doctor", value: "doctorName" },
        { text: "Diagnóstico", value: "diagnostic" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      sending: false,
    };
  },
  methods: {
    generatePDF(idMedicalPractice, time, idPatient) {
      this.sending = true;
      if (idMedicalPractice) {
        const fileName = `Consulta_Psicologica_${idMedicalPractice}_${moment(
          new Date(time)
        ).format("YYYY-MM-DD")}`;
        const data = {
          idMedicalPractice: idMedicalPractice,
          fileName: fileName,
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
          idPatient: idPatient,
        };
        PsychologyHistorialService.pdf(data)
          .then((res) => {
            if (res.status == 200 && res.data.type != "application/json") {
              this.$utilFront.openPDF(res.data);
            } else {
              this.$utilFront.displayErrorPdf(res.data);
            }
          })
          .finally(() => {
            //change action to table
            this.sending = false;
          });
      }
    },
  },
};
</script>

<style></style>
